import isEmpty from 'lodash/isEmpty';
import { GetStaticProps, NextPage } from 'next';
import React from 'react';

import HeadMeta from '@/components/static-pages/HeadMeta';
import TermsTemplate from '@/components/templates/TermsTemplate';
import { getStaticPageData } from '@/services/getPageData';

interface IProps {
  seoTitle: string;
  seoDescription: string;
  canonicalUrl: string;
  subheading: string;
  heading: string;
  contentBlocks: { raw: string; value: string; type: string }[];
  slug: string;
  noindex: boolean;
}

const Terms: NextPage<IProps> = props => {
  const { seoTitle, seoDescription, canonicalUrl, contentBlocks, slug, noindex } = props;

  return (
    <>
      <HeadMeta
        title={seoTitle}
        description={seoDescription}
        canonicalUrl={canonicalUrl}
        noindex={noindex}
      />
      <TermsTemplate seoTitle={seoTitle} contentBlocks={contentBlocks} slug={slug} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const pageData = await getStaticPageData({ locale, url_path: 'service-fees' });
  if (isEmpty(pageData)) {
    return {
      notFound: true,
      revalidate: true,
    };
  }
  const { heading, subheading, seo_title, seo_description, canonical_url, content_blocks } =
    pageData.metadata;
  const seoDescription = seo_description ? seo_description : subheading;
  const seoTitle = seo_title ? seo_title : heading;
  return {
    props: {
      seoTitle,
      seoDescription,
      canonicalUrl: canonical_url,
      subheading,
      contentBlocks: content_blocks,
      heading,
      slug: pageData.metadata.slug,
      noindex: !!pageData.fallback,
    },
    revalidate: 20,
  };
};

export default Terms;
